import { z } from "zod";

export const createUserAddressSchema = z.object({
  label: z.string().trim().max(100).optional(),
  recipientName: z.string().trim().min(1).max(150),
  phoneNumber: z
    .string()
    .trim()
    .regex(/^[0-9+\-\s]{6,30}$/, "Invalid phone number."),
  addressLine1: z.string().trim().min(1),
  addressLine2: z.string().trim().optional(),
  subdistrict: z.string().trim().max(100).optional(),
  district: z.string().trim().max(100).optional(),
  province: z.string().trim().max(100).optional(),
  postalCode: z.string().trim().max(10).optional(),
  latitude: z.number().min(-90).max(90).optional(),
  longitude: z.number().min(-180).max(180).optional(),
  isDefault: z.boolean().optional(),
});
export type CreateUserAddressInput = z.infer<typeof createUserAddressSchema>;

export const updateUserAddressSchema = createUserAddressSchema.partial();
export type UpdateUserAddressInput = z.infer<typeof updateUserAddressSchema>;
